/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'Doctor',
        title: 'Dashboard',
        type: 'basic',
        icon: 'assets/icons/dashboard.svg',
        link: '/doctor/dashboard',
    },
    {
        id: 'Admin',
        title: 'Dashboard',
        type: 'basic',
        icon: 'assets/icons/dashboard.svg',
        link: '/admin/dashboard',
    },
    {
        id: 'Doctor',
        title: 'Patient List',
        type: 'basic',
        icon: 'assets/icons/patient-menu.svg',
        link: '/doctor/patient-list',
        menuid: '0',
    },
    {
        id: 'Admin',
        title: 'Patient List',
        type: 'basic',
        icon: 'assets/icons/patient-menu.svg',
        link: '/admin/patient/list',
    },
    {
        id: 'Admin',
        title: 'Organization List',
        type: 'basic',
        icon: 'assets/icons/org-menu.svg',
        link: '/admin/organization/list',
    },
    {
        id: 'Admin',
        title: 'Kitting',
        type: 'basic',
        icon: 'assets/icons/kitting-menu.svg',
        link: '/admin/kitting/list',
    },
    {
        id: 'Doctor',
        title: 'Kitting',
        type: 'basic',
        icon: 'assets/icons/kitting-menu.svg',
        link: '/doctor/kitting/list',
        menuid: '5',
    },
    {
        id: 'Doctor',
        title: 'To Do',
        type: 'basic',
        icon: 'assets/icons/todo.svg',
        link: '/doctor/todo/list',
        menuid: '1',
    },
    {
        id: 'Doctor',
        title: 'User Profile',
        type: 'basic',
        icon: 'assets/icons/userProfile-old.svg',
        link: '/doctor/userprofile',
    },
    {
        id: 'Doctor',
        title: 'Alerts',
        type: 'basic',
        icon: 'assets/icons/alerts.svg',
        link: '/doctor/alerts/list',
        menuid: '2',
    },
    {
        id: 'Doctor',
        title: 'Billing',
        type: 'basic',
        icon: 'assets/icons/billing.svg',
        link: '/doctor/billing/list',
        menuid: '3',
    },
    {
        id: 'Admin',
        title: 'Transaction',
        type: 'basic',
        icon: 'assets/icons/billing.svg',
        link: '/admin/billing/list',
    },
    {
        id: 'Admin',
        title: 'Admin Management',
        type: 'basic',
        icon: 'assets/icons/userProfile.svg',
        link: '/admin/management/list',
    },
    {
        id: 'Admin',
        title: 'To Do',
        type: 'basic',
        icon: 'assets/icons/todo.svg',
        link: '/admin/todo/list',
        menuid: '8',
    },
    {
        id: 'Doctor',
        title: 'Records',
        type: 'basic',
        icon: 'assets/icons/records.svg',
        link: '/doctor/records/list',
        menuid: '4',
    },
    {
        id: 'Admin',
        title: 'Records',
        type: 'basic',
        icon: 'assets/icons/records.svg',
        link: '/admin/records/list',
    },
    {
        id: 'Admin',
        title: 'Departments',
        type: 'basic',
        icon: 'assets/icons/dep-menu.svg',
        link: '/admin/department/list'
    },
    {
        id: 'Admin',
        title: 'Patient Group',
        type: 'basic',
        icon: 'assets/icons/patient-group-menu.svg',
        link: '/admin/patient-group/list'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
